/**
 * @description Custom filters, which can be set if the exact price or time is unknown.
 */
enum ReceiptCustomFilter {
    ApproximateTime = "ApproximateTime",
    ApproximateAmount = "ApproximateAmount"
}

export default ReceiptCustomFilter;
